import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import utils from '../../utils'

function NavBar() {
    const navItems = [
        { to: '/', label: 'Home' },
        { to: '/houses', label: 'Houses' },
        { to: '/services', label: 'Services' },
        { to: '/about', label: 'About' },
        { to: '/contact', label: 'Contact' }
    ];
    const baseClass = "text-[#0F1715]/70 hover:text-[#0F1715] transition-all text-xs uppercase tracking-widest font-label border-b-2 border-transparent pb-1";
    const activeClass = "text-orange-500 font-bold border-orange-500 border-b-2 border-orange-500";
    return (
        <div className='fixed top-0 w-full z-20 md:px-2 bg-[#FAFAFA] border-b border-gray-200 flex justify-between items-center px-2  py-2 shadow-sm opacity-90'>
            <div className="navbar bg-base-100 nav-top max-w-7xl mx-auto">
                <div className="navbar-start gap-4">
                    <Link to='/' className="btn btn-ghost btn-sm text-xl font-serif text-[#0F1715] uppercase tracking-tighter">
                        {utils.siteName}
                    </Link>
                </div>
                <div className="navbar-center hidden md:flex">
                    <ul className="menu menu-horizontal">
                        {navItems.map((item) => (
                            <li key={item.to}>
                                <NavLink
                                    to={item.to}
                                    className={({ isActive }) =>
                                        `${baseClass} ${isActive ? activeClass : ''}`
                                    }
                                >
                                    {item.label}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="navbar-end space-x-1 items-center">
                    <Link
                        to={'/contact'}
                        className="bg-primary text-white hidden md:block px-6 py-2.5 rounded-xl text-xs uppercase tracking-widest font-label font-bold hover:opacity-90 active:scale-95 transition-all">
                        Book Now
                    </Link>
                    <label htmlFor="nav-drawer">
                        <div className="btn btn-ghost btn-circle">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h7" /></svg>
                        </div>
                    </label>
                </div>
            </div>
        </div>
    )
}

export default NavBar